module.exports = __webpack_public_path__ + "static/img/share02.6382318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share02.png
// module id = Mc7w
// module chunks = 1